var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Summary',{attrs:{"fixed-offering-name":_vm.offeringName,"investment-source-name":_vm.investmentSourceName,"optional-items":_vm.settingItems,"frequency":_vm.frequencies[_vm.settings.frequency].name,"amount":_vm.settings.amount}})}
var staticRenderFns = []

export { render, staticRenderFns }